import { useState, useCallback, useEffect } from 'react';
import styles from './passcodeModal.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import Spinner from '@src/components/spinner/Spinner';
import LockIcon from '@src/assets/icons/locksimple.svg?react';
import { useAuthToken } from '@hooks/useAuthToken';
import { TextInput, TextInputValue } from '@src/components/text-input/TextInput';

type Props = {
  open: boolean;
  passcode: string;
  onClose: () => void;
  handleSetPasscode: (passcode: string) => void;
};

function getElementsById(ids: any) {
  var idList = ids.split(" ");
  var results: any = [];
  for (var i = 0; i < idList.length; i++) {
      const item = document.getElementById(idList[i]);
      if (item) {
          results.push(item);
      }
  }
  return(results);
}

function PasscodeModal(props: Props) {
  const { open, onClose, passcode: currentCode, handleSetPasscode } = props;
  const [ passcode, setPasscode ] = useState(currentCode);
  const [ confirmPasscode, setConfirmPasscode ] = useState(currentCode);
  const [ beError, setBeError ] = useState('');
  const [ confirmPassword, setConfirmPassword ] = useState('');
  const [ verified, setVerified ] = useState(false);
  const { password } = useAuthToken();

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    const inputs: NodeListOf<HTMLInputElement> = getElementsById("passcode0 passcode1 passcode2 passcode3");
    inputs.forEach((input, key) => {
      if (key !== 0) {
        input.addEventListener("click", function () {
          inputs[0].focus();
          inputs.forEach(repeat => {
            repeat.value = ''
          })
        });
      } else {
        input.addEventListener("click", function () {
          inputs.forEach(repeat => {
            repeat.value = ''
          })
        });
      }
      input.addEventListener("keyup", function () {
        if (input.value) {
          if (key === 3) {
            const userCode = ['']
            inputs.forEach((input) => {
                userCode.push(input.value);
              }
            )
            setBeError('');
            setPasscode(userCode.join(''));
            const item = document.getElementById("repasscode0");
            item?.focus();
          } else {
            inputs[key + 1].focus();
          }
        }
      });
    });
  })

  useEffect(() => {
    const inputs: NodeListOf<HTMLInputElement> = getElementsById("repasscode0 repasscode1 repasscode2 repasscode3");
    inputs.forEach((input, key) => {
      if (key !== 0) {
        input.addEventListener("click", function () {
          inputs[0].focus();
          inputs.forEach(repeat => {
            repeat.value = ''
          })
        });
      } else {
        input.addEventListener("click", function () {
          inputs.forEach(repeat => {
            repeat.value = ''
          })
        });
      }
      input.addEventListener("keyup", function () {
        if (input.value) {
          if (key === 3) {
            const userCode = ['']
            inputs.forEach((input) => {
                userCode.push(input.value);
              }
            )
            setBeError('');
            setConfirmPasscode(userCode.join(''));
          } else {
            inputs[key + 1].focus();
          }
        }
      });
    });
  })

  const handleSave = useCallback(() => {
    if (verified) {
      if (passcode && confirmPasscode) {
        if (passcode !== confirmPasscode) {
          setBeError('Passcode and confirm passcode should be equal.');
          return;
        }
      }
      setBeError('');
      handleSetPasscode(passcode);
    } else {
      if (password !== confirmPassword) {
        setBeError('Incorrect Password. Please try again');
        return;
      }
      setBeError('');
      setVerified(true);
    }
  }, [handleSetPasscode, setBeError, passcode, confirmPasscode, verified, password, confirmPassword])

  const handleChangeText = (value: TextInputValue) => {
    setBeError('');
    setConfirmPassword(value.toString())
  }

  return (
    <Modal open={open} onClose={handleClose} className={styles.wrapper}>
      <div>
        <LockIcon width={44} height={44} />
        <div className={styles.title}>{verified ? 'Set your Passcode' : 'Please re-type your password:'}</div>
          <div className={styles.content}>
          {verified ? <>
            <span>Write your passcode:</span>
            <form id="Form" className={styles.passcodeForm}>
              <input id="passcode0" type="password" maxLength={1} autoComplete="off"/>
              <div className={styles.divider}/>
              <input id="passcode1" type="password" maxLength={1} autoComplete="off"/>
              <div className={styles.divider}/>
              <input id="passcode2" type="password" maxLength={1} autoComplete="off"/>
              <div className={styles.divider}/>
              <input id="passcode3" type="password" maxLength={1} autoComplete="off"/>
            </form>
            <span>Repeat passcode:</span>
            <form id="repeatForm" className={styles.retypeForm}>
              <input id="repasscode0" type="password" maxLength={1} autoComplete="off"/>
              <div className={styles.divider}/>
              <input id="repasscode1" type="password" maxLength={1} autoComplete="off"/>
              <div className={styles.divider}/>
              <input id="repasscode2" type="password" maxLength={1} autoComplete="off"/>
              <div className={styles.divider}/>
              <input id="repasscode3" type="password" maxLength={1} autoComplete="off"/>
            </form>
          </> : <TextInput allowSpecialCharacters id="password" hasError={false} subTitle={''} type="password"  placeholder={'Type your password'} value={confirmPassword} label={''} onChange={handleChangeText} />
          }
           
            {Boolean(beError) && <div className={styles.error}>{beError}</div>}
            <div className={styles.action}>
              <Button disabled={verified ? (!passcode || !confirmPasscode) : !confirmPassword} size="small" leftIcon={false ? <Spinner width={20} height={20} /> : undefined} className={styles.okButton} onClick={handleSave} label={verified ? 'Set Passcode': 'Continue'}/>
            </div>
          </div>
      </div>
    </Modal>
  );
}

export default PasscodeModal;
